import { useTranslation } from "react-i18next";

export default function LoginCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.login");
}
